import { cn } from '@/lib/utils'
import { buttonVariants } from "@/components/ui/button";
import { siteConfig } from '@/config/site'
import React from 'react'

type Props = {}

const JobSearch = (props: Props) => {
  return (
    <section className="relative overflow-hidden py-20 md:py-28">
      <div className="container relative z-10 mx-auto max-w-3xl px-6 text-center">
        <div
          data-aos="fade-up"
          data-aos-duration="600"
          className="mb-4 inline-flex items-center gap-2 rounded-full border border-indigo-200/60 bg-indigo-50/60 px-4 py-1.5 text-xs font-medium text-indigo-600 backdrop-blur-sm"
        >
          <span className="relative flex h-2 w-2">
            <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-indigo-400 opacity-60" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-indigo-500" />
          </span>
          We&apos;re hiring
        </div>

        <h1
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="100"
          className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-slate-900"
        >
          Build the Future of{" "}
          <span className="bg-gradient-to-r from-indigo-600 via-violet-600 to-purple-600 bg-clip-text text-transparent">
            AI with Us
          </span>
        </h1>

        <p
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="200"
          className="mt-5 text-base md:text-lg text-slate-500 leading-relaxed max-w-xl mx-auto"
        >
          Join <b className="text-slate-700">{siteConfig.name}</b> and work on cutting-edge AI chatbot technology.
          We&apos;re looking for passionate people who love building amazing products.
        </p>

        <div
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="300"
          className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <div className="relative w-full">
            <svg className="absolute left-4 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input
              type="text"
              placeholder="Search for roles..."
              className="w-full h-12 pl-11 pr-4 bg-white/80 backdrop-blur-sm border border-slate-200/80 rounded-xl text-sm text-slate-700 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-300 transition-all duration-200 shadow-sm"
            />
          </div>
          <button
            type="submit"
            className="h-12 shrink-0 w-full sm:w-auto px-7 rounded-xl bg-gradient-to-r from-indigo-600 to-violet-600 text-sm font-semibold text-white shadow-lg shadow-indigo-500/20 hover:shadow-xl hover:shadow-indigo-500/25 hover:brightness-110 active:scale-[0.97] transition-all duration-200"
          >
            Search
          </button>
        </div>

        {/* Stats */}
        <div
          data-aos="fade-up"
          data-aos-duration="700"
          data-aos-delay="400"
          className="mt-12 flex items-center justify-center gap-8 md:gap-12"
        >
          {[
            { num: "100%", label: "Remote" },
            { num: "10+", label: "Open Roles" },
            { num: "5+", label: "Countries" },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-slate-900">{stat.num}</div>
              <div className="text-xs text-slate-400 mt-0.5">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default JobSearch